import {Injectable} from '@angular/core';
import {MachineType} from "../util/machine";

/***
 * jpush  service  工具类,jpush使用 直接调用，新增功能根据插件文档去使用
 */
@Injectable()
export class JpushService {

  constructor(private mType: MachineType) {
  }

  initJpush() {
  	alert(!this.mType.isMobile()||this.mType.isMobileWeb());
    if (!this.mType.isMobile()||this.mType.isMobileWeb()) {
      return;
    }
    window['plugins'].jPushPlugin.init();
    if (this.mType.isIos()) {
      window['plugins'].jPushPlugin.setDebugModeFromIos();
      window['plugins'].jPushPlugin.setApplicationIconBadgeNumber(0);
    } else {
      window['plugins'].jPushPlugin.setDebugMode(true);
      window['plugins'].jPushPlugin.setStatisticsOpen(true);
    }
    this.jPushAddEventListener();
  }

  private jPushAddEventListener() {
    //判断系统设置中是否允许当前应用推送
    window['plugins'].jPushPlugin.getUserNotificationSettings(result => {
      if (result == 0) {
        alert('系统设置中已关闭应用推送');
      } else if (result > 0) {
        alert('系统设置中打开了应用推送');
      }
    });

    //点击通知进入应用程序时会触发的事件
    document.addEventListener("jpush.openNotification", event => {
      let content = this.mType.isIos() ? event['aps'].alert : event['alert'];
      alert("jpush.openNotification" + content+"||*"+event['extras'].test+"||*"+event['extras'].url+"||*"+event['title']);
    }, false);

    //收到通知时会触发该事件
    document.addEventListener("jpush.receiveNotification", event => {
      let content = this.mType.isIos() ? event['aps'].alert : event['alert'];
      alert("jpush.receiveNotification" + content);
    }, false);

    //收到自定义消息时触发这个事件
    document.addEventListener("jpush.receiveMessage", event => {
      let message = this.mType.isIos() ? event['content'] : event['message'];
      alert("jpush.receiveMessage" + message);
    }, false);


    //设置标签/别名回调函数
    document.addEventListener("jpush.setTagsWithAlias", event => {
      console.log("onTagsWithAlias");
      let result = "result code:" + event['resultCode'] + " ";
      result += "tags:" + event['tags'] + " ";
      result += "alias:" + event['alias'] + " ";
      alert(result);
    }, false);

  }

  //设置标签
  public setTags() {
    if (!this.mType.isMobile()||this.mType.isMobileWeb()) {
      return;
    }
    let tags = this.mType.isAndroid() ? ['android'] : ['ios'];
    alert('设置setTags:' + tags);
    window['plugins'].jPushPlugin.setTags(tags);
  }

  //设置别名,一个用户只有一个别名
  public setAlias(userId) {
    if (!this.mType.isMobile()||this.mType.isMobileWeb()) {
      return;
    }
    alert('设置setAlias:' + userId);
    //ios设置setAlias有bug,值必须为string类型,不能是number类型
    window['plugins'].jPushPlugin.setAlias('' + userId);
  }
  //获取唯一的该设备的标识
  public getRegistrationID(){
  	if (!this.mType.isMobile()||this.mType.isMobileWeb()) {
      return;
    }
  	window['plugins'].jPushPlugin.getRegistrationID(function(data) {
       alert("JPushPlugin:registrationID is " + data);
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/service/jpushservice.ts